<template>
  <div v-if="scheduledMessages.length" class="bg-n-blue-2 dark:bg-n-slate-2 border-t border-n-weak px-2 pt-2 pb-0 flex flex-col gap-2 relative z-10 w-full rounded-t-xl mt-2">
    <div class="font-semibold text-n-slate-11 text-xs px-2 flex items-center gap-1 uppercase tracking-wide">
      <span class="i-lucide-clock w-3.5 h-3.5"></span> Mensagens Agendadas
    </div>
    <div v-for="msg in scheduledMessages" :key="msg.id" class="flex justify-between items-center bg-white dark:bg-slate-900 border border-n-weak rounded-lg shadow-sm px-3 py-2 mb-2">
      <div class="flex flex-col truncate pr-4">
        <span class="text-[10px] text-n-brand font-medium mb-0.5">{{ formatTime(msg.scheduled_at) }}</span>
        <span class="truncate text-n-slate-12 text-sm">{{ msg.content }}</span>
      </div>
      <div class="flex justify-end items-center gap-2">
        <button @click="openEditModal(msg)" class="p-1 text-n-slate-10 hover:text-n-brand transition-colors" v-tooltip.top-end="'Editar Agendamento'">
          <span class="i-lucide-pencil w-3.5 h-3.5 block"></span>
        </button>
        <button @click="cancelMessage(msg.id)" class="p-1 text-n-slate-10 hover:text-red-500 transition-colors" v-tooltip.top-end="'Cancelar Envio'">
          <span class="i-lucide-trash w-3.5 h-3.5 block"></span>
        </button>
      </div>
    </div>
    
    <EditScheduledMessageModal
      v-if="showEditModal"
      :show="showEditModal"
      :message="selectedMessage"
      :is-saving="isSaving"
      @close="closeEditModal"
      @save="saveMessage"
    />
  </div>
</template>

<script>
import { useAlert } from 'dashboard/composables';
import { mapGetters } from 'vuex';
import EditScheduledMessageModal from './EditScheduledMessageModal.vue';

export default {
  components: {
    EditScheduledMessageModal,
  },
  props: {
    conversationId: {
      type: [Number, String],
      required: true,
    }
  },
  data() {
    return {
      scheduledMessages: [],
      showEditModal: false,
      selectedMessage: null,
      isSaving: false,
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
    }),
  },
  mounted() {
    this.fetchMessages();
    window.addEventListener('scheduledMessageCreated', this.fetchMessages);
  },
  unmounted() {
    window.removeEventListener('scheduledMessageCreated', this.fetchMessages);
  },
  watch: {
    conversationId() {
      this.fetchMessages();
    }
  },
  methods: {
    async fetchMessages() {
      if (!this.conversationId) return;
      try {
        const response = await window.axios.get(`/api/v1/accounts/${this.accountId}/conversations/${this.conversationId}/scheduled_messages`);
        this.scheduledMessages = response.data;
      } catch (error) {
        // fail silently
      }
    },
    async cancelMessage(id) {
      try {
        await window.axios.delete(`/api/v1/accounts/${this.accountId}/conversations/${this.conversationId}/scheduled_messages/${id}`);
        this.scheduledMessages = this.scheduledMessages.filter(m => m.id !== id);
        useAlert('Agendamento cancelado com sucesso.');
      } catch (error) {
        useAlert('Erro ao cancelar agendamento.');
      }
    },
    formatTime(dateString) {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'short' }).format(date);
    },
    openEditModal(msg) {
      this.selectedMessage = msg;
      this.showEditModal = true;
    },
    closeEditModal() {
      this.showEditModal = false;
      this.selectedMessage = null;
    },
    async saveMessage(payload) {
      this.isSaving = true;
      try {
        const response = await window.axios.patch(
          `/api/v1/accounts/${this.accountId}/conversations/${this.conversationId}/scheduled_messages/${payload.id}`,
          { content: payload.content, scheduled_at: payload.scheduled_at }
        );
        const index = this.scheduledMessages.findIndex(m => m.id === payload.id);
        if (index !== -1) {
          this.scheduledMessages.splice(index, 1, response.data);
        }
        useAlert('Agendamento atualizado com sucesso.');
        this.closeEditModal();
      } catch (error) {
        useAlert(error?.response?.data?.errors?.[0] || 'Erro ao atualizar agendamento.');
      } finally {
        this.isSaving = false;
      }
    }
  }
}
</script>
